export function validProgress(progress) {
  if (!progress || progress < 0) {
    return 0;
  }
  if (progress > 100) {
    return 100;
  }
  return progress;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_ant-design-vue@1.7.8@ant-design-vue/es/progress/utils.js
// module id = null
// module chunks = 